import { useEffect } from "react";
import { history } from "common/components/history";
import { Provider } from "react-redux";
import { Switch, Redirect, Route, Router } from "extensions/react-router";

import { showError } from "common/components/error";
import { AdminsListRedux } from "common/components/admins";

import { store } from "common/store";

import { PazienError } from "common/helpers/errors";
import { pazienHistory } from "common/components/pazienHistory";

import { SessionTimeoutModal } from "common/components/sessionTimeoutModal";
import { HistoryListener } from "common/components/historyListener";
import { AdminDashboardRouter } from "administrator/features/dashboard/adminDashboardRouter";
import { CredentialsRouter } from "administrator/features/credentials/credentialsRouter";
import { UsersRouter } from "administrator/features/users/usersRouter";
import { MerchantsRouter } from "administrator/features/merchants/merchantsRouter";
import { ReportsRouter } from "administrator/features/reports/reportsRouter";
import { RequestsRouter } from "administrator/features/requests/requestsRouter";
import { SessionsRouter } from "administrator/features/sessions/sessionsRouter";
import { EmailRouter } from "administrator/features/email/emailRouter";
import { AppRegistryRouter } from "administrator/features/appregistry/appRegistryRouter";

import { LoginRouter } from "common/features/login/loginRouter";
import { DashboardRouter } from "./features/dashboard/dashboardRouter";
import { Reconciliation3Router, ReconciliationRouter } from "./features/reconciliation3/reconciliationRouter";
import { SearchRouter } from "./features/search/searchRouter";
import { AnalyticsRouter } from "./features/analytics/analyticsRouter";
import { DownloadsRouter } from "./features/downloads/downloadsRouter";
import { PreferencesRouter } from "./features/preferences/preferencesRouter";
import { DevRouter } from "./features/dev/devRouter";
import { ReportsRouter as ReportsRouter2 } from "./features/reports2/reportsRouter";
import { SupportRouter } from "./features/support/supportRouter";
import { AlertsRouter } from "./features/alerts2/alertsRouter";

export function MerchantRouter() {
    return (
        <Router history={history}>
            <HistoryListener />
            <SessionTimeoutModal/>
            <Switch>
                <Route path="/administrator">
                    <Redirect to="/merchant/administrator" />
                </Route>
                <Route path="/merchant">
                    <LoginRouter />
                    <DashboardRouter />
                    <ReconciliationRouter/>
                    <Reconciliation3Router/>
                    <AlertsRouter/>
                    <SearchRouter/>
                    <AnalyticsRouter/>
                    <DownloadsRouter/>
                    <PreferencesRouter/>
                    <ReportsRouter2/>
                    <DevRouter/>
                    <SupportRouter/>

                    <Route path="/merchant/administrator">
                        <CredentialsRouter/>
                        <AdminDashboardRouter />
                        <UsersRouter/>
                        <MerchantsRouter/>
                        <ReportsRouter/>
                        <RequestsRouter/>
                        <SessionsRouter/>
                        <EmailRouter/>
                        <AppRegistryRouter/>
                    </Route>
                    <Route exact path="/merchant/administrator">
                        <Redirect to="/merchant/administrator/credentials"/>
                    </Route>

                    <Route path="/merchant/insufficient_privileges" component={InsufficientPrivilegesError} />

                    <Route exact path="/merchant">
                        <Redirect to="/merchant/login"/>
                    </Route>
                </Route>
                <Route path="*">
                    <Redirect to="/merchant/login"/>
                </Route>
            </Switch>
        </Router>
    );
}

class InsufficientPrivileges extends PazienError {
    name = "InsufficientPrivileges";

    constructor(props) {
        props.header = "Access denied";
        props.message = "You do not have permission to view this page. If you believe this is an error, please contact your admins:";
        props.hideDetails = true;

        super(props);
        this.custom = true;
        this.customActions = [{
            label: "Return to sign in",
            onClick: (e) => {
                e.preventDefault();
                pazienHistory.navigate("logout", { trigger: true });
            }
        }];
    }
}

function InsufficientPrivilegesError({ match }) {
    useEffect(() => {
        if (match) {
            showError(new InsufficientPrivileges({ info: <Provider store={store}><AdminsListRedux /></Provider> }));
        }
    });

    return null;
}
